// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609212047/js/" + chunkId + "." + {"44":"66706fac","225":"17b6cc8c","481":"9aa177b6","486":"c50ba877","770":"27492d64"}[chunkId] + ".0.5545403391772487.chunk.js";
};